export default "__VITE_ASSET__e1bad82a__"